export enum HouseOccupationType {
  Proprietario = '1',
  IntestatarioContrattoAgenziaEntrate = '2',
  IntestatarioContrattoImmobileResidenzialePubblica = '3',
  ComodatarioAgenziaEntrate = '4',
  Usufruttuario = '5',
  OccupanteLegittimo = '6',
}

export enum TipoOccupazioneLegittima {
  AffittuarioNonAgenziaEntrate = '601',
  ComodatariNonAgenziaEntrate = '602',
  AutorizzatoERP = '603',
  OspiteProprietario = '604',
  OspiteIntestatarioContrattoLocazioneComodatarioUsufruttuario = '605',
  OspiteIntestatarioERP = '606',
  OspiteETSStrutturaSanitariaOPrivate = '607',
}

export enum TipoOccupazioneLegittimaFamigliaEsistente {
  AutorizzatoERP = '703',
  OspiteIntestatarioERP = '706',
}

export const TIPO_OCCUPAZIONE_LEGITTIMA_LABELS: Record<TipoOccupazioneLegittima, string> = {
  [TipoOccupazioneLegittima.AffittuarioNonAgenziaEntrate]: 'Affittuario non Agenzia delle Entrate',
  [TipoOccupazioneLegittima.ComodatariNonAgenziaEntrate]: 'Comodatario non Agenzia delle Entrate',
  [TipoOccupazioneLegittima.AutorizzatoERP]: 'Autorizzato ERP',
  [TipoOccupazioneLegittima.OspiteProprietario]: 'Ospite del proprietario',
  [TipoOccupazioneLegittima.OspiteIntestatarioContrattoLocazioneComodatarioUsufruttuario]:
    'Ospite intestatario contratto di locazione, comodatario o usufruttuario',
  [TipoOccupazioneLegittima.OspiteIntestatarioERP]: 'Ospite intestatario ERP',
  [TipoOccupazioneLegittima.OspiteETSStrutturaSanitariaOPrivate]:
    'Ospite ETS, struttura sanitaria o privata',
};
